<template>
  <div class='saved-reports-header'>
    <SearchInput
      class='search-reports-input'
      name="search-reports"
      placeholder="Search Reports"
      :value="searchTerm"
      @input="(value) => $emit('updateSearchTerm', value)"
    ></SearchInput>

    <PrimaryButton @click="openScheduleReportSlideOut">
      Create New Report
    </PrimaryButton>
  </div>
</template>

<script>
import { SearchInput, PrimaryButton } from '@mikmak/components';

export default {
  components: {
    SearchInput,
    PrimaryButton,
  },
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
  },
  methods: {
    openScheduleReportSlideOut() {
      this.$router.push({ name: 'explorer-base' });
    },
  },
};
</script>

<style>
.saved-reports-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.search-reports-input {
  max-width: 300px;
}
</style>
